<script>
export default {
  name: "approve_maintenance_buttons",
  props: {
    disabledGoToManifest: {
      type: Boolean,
      default: false,
    },
    hideBtnManifest:{
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    isApproved: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    comment: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    back() {
      this.$emit("back");
    },
    editManifest() {
      this.$emit("editManifest");
    },
    openApprovalHistoryModal() {
      this.$emit("openApprovalHistoryModal");
    },
  }
}
</script>

<template>
  <div class="d-flex justify-content-center gap-2">
    <div class="approve-comment">
      <b-form-input
        placeholder="修正内容"
        v-model="comment"
      ></b-form-input>
    </div>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="openApprovalHistoryModal"
      id="edit-history-button"
    >
      <i class="fas fa-history"></i> 修正履歴
    </button>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="submit"
      id="register-edit-button"
    >
      <i class="fas fa-pencil-alt"></i>
      <template v-if="isApproved">
        {{ this.$lang.button.edit }}
      </template>
      <template v-else>
        {{ this.$lang.button.register }}
      </template>
    </button>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="back"
      id="back-button"
    >
      <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
    </button>
    <button
      v-if="!hideBtnManifest"
      :disabled="disabledGoToManifest"
      class="btn btn-primary waves-effect waves-light"
      @click="editManifest"
      id="manifest-button"
    >
      <i class="fas fa-file-alt"></i> マニフェスト
    </button>
  </div>
</template>
